<template>
    <div class="hogarth-ic-logo">
        <HogarthLogo class="hogarth-logo" />
        <div class="team-name">Intelligent Content</div>
    </div>
</template>

<script lang="ts" setup>
import HogarthLogo from "@/assets/ic_logo.svg";
</script>

<style lang="scss">
@use "@style/variables" as *;

$silka-family:
    "Silka", "Open Sans", "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑",
    Arial, sans-serif;

.team-name {
    font-family: $silka-family;
    font-weight: 700;
    font-size: 19px;
    color: $hogarth-yellow;
}
.hogarth-ic-logo {
    margin-bottom: 41px;
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    &--large {
        .hogarth-logo {
            width: 100%;
        }
    }

    .hogarth-logo {
        width: 50%;
        height: 50%;
        margin-bottom: $spacing-small;
    }

    .ipe {
        font-size: 12.7px;
        font-family: $silka-family;
        margin-bottom: $spacing-large;
    }
}
</style>
